import { useMemo } from "react";
import cn from "classnames";
import { FCX } from "@datassential/platform-ui-lib";
import "./CircularBar.styles.scss";

interface iProps {
    percentage: number;
    id: string;
}

const CircularBar: FCX<iProps> = ({ percentage, id, className }) => {
    const strokeDasharray = percentage ? (percentage === 100 ? 590 : 575) : 590;
    const dashOffset = useMemo(
        () => strokeDasharray - ((strokeDasharray - 5) * percentage) / 100,
        [percentage, strokeDasharray],
    );

    return (
        <div className={cn("CircularBar", className)}>
            <div className="CircularBar__circle">
                <svg className="CircularBar__circle-svg">
                    <circle
                        className="CircularBar__background"
                        cx="100"
                        cy="100"
                        r="93"
                    />
                    <circle
                        style={{
                            strokeDashoffset: dashOffset,
                            strokeDasharray,
                        }}
                        stroke="#56CCF2"
                        fill="none"
                        className="CircularBar__line"
                        cx="100"
                        cy="100"
                        r="93"
                    />
                </svg>
            </div>
        </div>
    );
};

export default CircularBar;
